import React, { Component } from 'react'
import './Stores.css'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { mergeOpenPopup, closePopup } from '../../actions/modalAction'
import { getCountryList } from '../../actions/country'
import { Config } from '../../Config'
import { CommonConstants } from '../../Constants'
import Api from '../../Api'
import AuthenticationService from '../Security/AuthenticationService'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import Draggable from 'react-draggable'
import { checkAccess, getPermission } from '../../actions/permissions'
import { CountryOptions } from '../Common/Country'
// This componenet is used for the store detail popup and store detail page.
class StoreDetailsComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      showStores: this.props.showStores,
      show: false,
      Store_Country_ID: 1,
      timeZones: [],
      Store_TZ: '',
      isValid: true,
      errorMessage: [],
      isSuccess: false,
      Store_Name: '',
      isViewDetailsPage: false,
      suid: null
    }
    this.api = new Api()
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.storeTabs = this.storeTabs.bind(this)
    this.mergePopUp = this.mergePopUp.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.checkUserUUID = this.checkUserUUID.bind(this)
    this.handleRemoveStore = this.handleRemoveStore.bind(this)
    props.getPermission()
  }
  // Getting the country list from the service.
  componentDidMount () {
    this.props.getCountryList()
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.getAllTimeZones
    this.api.getData(url, result => {
      if (result.status) {
        this.setState({ timeZones: result.data })
      }
    })
  }

  // Reload the page.
  pageRefresh (){
    window.location.reload();
  }

  // Storing the props values in the state.
  componentWillReceiveProps (newProps) {
    this.setState({
      Store_Name: newProps.storesDetails.Store_Name,
      Store_TZ: newProps.storesDetails.Timezone,
      suid: newProps.storesDetails.Store_UID
    })
    if (this.props && this.props.history && this.props.history.location.pathname === CommonConstants.StoreSettingsPage) {
      this.setState({ isViewDetailsPage: true })
    }
  }
  // This functions displays store popup
  mergePopUp () {
    this.setState({
      show: true
    })
    this.props.mergeOpenPopup()
    this.props.closePopup()
  }

  storeTabs () {
    const language = this.state.currentLanguage
    const mergeClass = this.authService.isAdmin() ? 'merge-statement' : 'merge-statement-masquerade'
    if (this.props.storeModelPopupIsAdmin && this.isRemoveStore(this.props.Device_Details)) {
      return (
        <div className={mergeClass}>{t[language].storemergetext} <a className='merge-link' onClick={this.mergePopUp}> {t[language].clickhere}</a></div>
      )
    }
  }
  // Updating the state values on input change.
  handleInputChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  // Validates the edit store basic fields.
  handleValidation () {
    const language = this.state.currentLanguage
    let errors = []
    if (this.authService.isAdmin() === true && this.checkUserUUID() === false) {
      let storeTZ = this.state.Store_TZ
      if (storeTZ === '' || storeTZ === null) {
        errors.push(t[language].storeTZBlank)
      }
      this.setState({ errorMessage: errors[0] })
      if (errors.length > 0) {
        this.setState({ isValid: false, isSuccess: false })
        return false
      }
      this.setState({ isValid: true })
      return true
    } else {
      let storeName = (this.state.Store_Name)
      let blackListWords = 'anal,anus,arse,ass,ballsack,balls,bastard,bitch,biatch,blowjob,blow job,bollock,bollok,boner,boob,bugger,bum,butt,buttplug,clitoris,cock,coon,crap,cunt,damn,dick,dildo,dyke,fag,feck,fellate,fellatio,felching,fuck,f u c k,fudgepacker,fudge packer,flange,Goddamn,God damn,hell,homo,jerk,jizz,knobend,knob end,labia,lmao,lmfao,muff,nigger,nigga,omg,obama,penis,piss,poop,prick,pube,pussy,queer,scrotum,sex,shit,s hit,sh1t,slut,smegma,spunk,trump,tit,tosser,turd,twat,vagina,wank,whore,wtf'
      let errors = []
      if (storeName) {
        if (storeName.length === 1) {
          errors.push('StoreSettingsErrorNameInvalid')
          this.props.closePopup()
          this.props.history.push('/error', errors)
          return false
        }
        let input = new RegExp(storeName, 'gi')
        let res = blackListWords.match(input)
        if (res) {
          errors.push('StoreSettingsErrorNameInvalid')
          this.props.closePopup()
          this.props.history.push('/error', errors)
          return false
        } else {
          return true
        }
      }
      return true
    }
  }
  // Making a service call on submitting the form.
  handleSubmit () {
    const language = this.state.currentLanguage
    let errors = []
    if (this.handleValidation()) {
      let url = Config.apiBaseUrl + CommonConstants.apiUrls.saveStore
      let data = {}
      // For Public user - request data.
      if (this.checkUserUUID() || this.authService.isAdmin() === false) {
        data = {
          isAdmin: 0,
          suid: this.props.storesDetails.Store_UID,
          StoreNumber: this.props.storesDetails.Store_Number,
          storeID: this.props.storesDetails.Store_ID,
          StoreName: this.state.Store_Name,
          Company_ID: this.props.storesDetails.Store_Company_ID
        }
      } else {
        // For Admin - request data
        data = {
          isAdmin: 1,
          storeID: this.props.storesDetails.Store_ID,
          timeZone: this.state.Store_TZ
        }
      }

      // Making a service call
      this.api.postData(url, data, result => {
        if (result.status && result.updatedRecords > 0) {
          if (this.checkUserUUID() || this.authService.isAdmin() === false) {
            let data = {
              key: 'storeSettingsConfirmUpdateSucessful'
            }
            this.props.closePopup()
            this.props.history.push('/message', data.key)
          } else {
            this.setState({ isSuccess: true, successMessage: t[language].storeTZSaveSuccess })
          }
        } else {
          errors.push(t[language].internalservererror)
          this.setState({ errorMessage: errors[0], isValid: false })
        }
      })
    }
  }
  // Admin - This function checks for the UUID presence on the url, if the Admin is viewing the user details.
  checkUserUUID () {
    if (window.location) {
      const params = new URLSearchParams(window.location.search)
      if (params) {
        const uuid = params.get('uuid') ? params.get('uuid') : null
        if (uuid === 'null' || uuid === null) {
          return false
        } else {
          return true
        }
      }
      return false
    }
    return false
  }

  // Checking the condition for showing the remove system on the store popup
  isRemoveStore (deviceDetails) {
    if (deviceDetails) {
      let device = deviceDetails[0]
      if ((device.Device_Name !== null && device.Device_Name !== undefined) && (device.Device_MainVersion !== null && device.Device_MainVersion !== undefined)) {
        if (device.Device_IsActive === 1 || device.Device_IsActive === 0) {
          return true
        }
        return false
      }
      return false
    }
  }
  // Confirming the remove store action by making a service call.
  ConfirmRemoveStore () {
    const language = this.state.currentLanguage
    let errors = []
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.removeStore + '?suid=' + this.state.suid
    this.api.getData(url, result => {
      if (result.status && result.isStoreRemoved) {
        if (this.checkUserUUID() || this.authService.isAdmin() === false) {
          let data = {
            key: 'storeRemoveSuccess'
          }
          this.props.closePopup()
          this.props.history.push('/message', data.key)
        } else {
          
          //this.setState({ isSuccess: true, successMessage: t[language].storeRemoveSuccess })
          this.storeRemovePopupSuccess();
        }
      } else {
        errors.push(t[language].storeRemoveFailure)
        //this.setState({ errorMessage: errors[0], isValid: false })
        this.storeRemovePopupError();
      }
    })
  }

  // Showing the confirmation popup for removing the store.
  handleRemoveStore () {
    const language = this.state.currentLanguage
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <Draggable>
            <div className='remove-store-dialog'>
              <div className='custom-ui'>
                <span className='custom-ui-header'><h1>{t[language].ConfirmationRequired} </h1></span>
                <div className='remove-store-dialog-content'>
                  <p>{t[language].removeStoreConfirm}</p>
                  <p><span className='warning-store-dialog-content'><span className='redText'><strong>{t[language].warning}</strong></span>: {t[language].actioncannotbeundone}</span></p>
                </div>
                <div className='store-merge-footer'>
                  <div className='merge-footer-buttonset'>
                    <button type='button' className='rounded-corners' onClick={() => {
                      this.ConfirmRemoveStore()
                      onClose()
                    }}>{t[language].confirm}</button>
                    <button type='button' className='rounded-corners' onClick={onClose}>{t[language].close}</button>
                  </div>
                </div>
              </div>
            </div>
          </Draggable>
        )
      }
    })
  }

  storeRemovePopupSuccess(){
    confirmAlert({
      customUI:({title,message,onClose})=>{
        return(
          <Draggable>
          <div className='popup modal_dialog'>
            <p className='popu_Title'>Confirmation Required</p>
            <p className='popup_message successMsg'>Success! The requested store has been removed.</p>
            <div className='popup_buttons'>
              <div className='buttonSet' />
              <div className='popup_button'>
                <button className='popup_buttons buttons' onClick={()=>{
                  this.pageRefresh();
                  onClose();
                }}>Close</button>
              </div>
            </div>
          </div>
          </Draggable>
        )
      }
    })
  }

    // Store Remove Error popup
    storeRemovePopupError (error) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <Draggable>
            <div className='popup'>
              <p className='popup_Title'>Confirmation Required</p>
              <p className='popup_message warning'> Error! Something went wrong, please try your request again.</p>
              <p className='popup_message'>{error}</p>
              <div className='popup_buttons'>
                <div className='buttonSet' />
                <div className='popup-button'>
                  <button className='popup_buttons buttons' onClick={() => {
                    onClose()
                  }}>Close</button>
                </div>
              </div>
            </div>
            </Draggable>
          )
        }
      })
    }

  render () {
    const language = this.state.currentLanguage
    const saveBtn = {
      margin: '15px 0px 0px 0px'
    }
    // Timezone List
    const timeZoneList = (datalist, selectedvalue) => {
      if (datalist != null) {
        return datalist.map((data) => {
          if (selectedvalue === data.name) {
            return <option value={data.Id} selected={selectedvalue === data.Name}>{data.Name}</option>
          } else {
            return <option value={data.Name}>{data.Name}</option>
          }
        })
      }
    }
    const storedetails = this.props.storedetails
    return (
      <div>
        <div className={'storePopupForm ' + (storedetails ? 'stores_Details' : '')}>
          <h4 className={'cib_header ' + (storedetails ? 'show' : 'hide')}> {t[language].storeListStoreDetails} </h4>
          <div className={'saveStoreTZErrors ' + (this.state.isValid ? 'hide' : 'show')} >
            <span>{this.state.errorMessage}</span>
          </div>
          <div className={'saveStoreTZSuccess ' + (this.state.isSuccess ? 'show' : 'hide')} >
            <span>{this.state.successMessage}</span>
          </div>
        </div>
        <table className='user_form'>
          <tbody>
            <tr className={(storedetails ? 'hide-table-row' : 'show-table-row')}>
              <th><label htmlFor='Store_Brand_ID'>{t[language].settingsStoresCIBBrand}
                {this.authService.isAdmin() ? <span className='redText'>*</span> : ''}
              </label></th>
              <td>
                <select name='Store_Brand_ID' id='Store_Brand_ID' disabled='disabled'>
                  <option value="Checker's" selected='selected'>{this.props.storesDetails.Brand_Name}</option>
                </select>
              </td>
            </tr>
            <tr className={(storedetails ? 'show-table-row' : 'hide-table-row')}>
              <th><label htmlFor='Store_Brand_ID'>{t[language].settingsStoresCIBBrand}
                {this.authService.isAdmin() ? <span className='redText'>*</span> : this.state.isViewDetailsPage ? <span className='redText'>*</span> : ''}
              </label></th>
              <td>
                <table className='storedetails'>
                  <tr>
                    <td>
                      <select name='Store_Brand_ID' id='Store_Brand_ID' disabled='disabled'>
                        <option value="Checker's" selected='selected'>{this.props.storesDetails.Brand_Name}</option>
                      </select>
                    </td>
                    <th >
                      <label htmlFor='Store_Number'>{t[language].settingsStoresStoreNumber} #:<span className='redText'>*</span></label>
                    </th>
                    <td><input type='text' maxLength='100' name='Store_Number' id='Store_Number' value={this.props.storesDetails.Store_Number} disabled='disabled' /></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr className={(storedetails ? 'hide-table-row' : 'show-table-row')}>
              <th><label htmlFor='Store_Name'> {t[language].settingsStoresStoreName}:</label></th>
              <td><input type='text' maxLength='20' name='Store_Name' value={this.state.Store_Name} disabled={checkAccess(CommonConstants.userPermissions.EditStoreBasic) ? '' : 'disabled'} onChange={(e) => { this.handleInputChange(e) }} />
                <input type='hidden' name='Store_ID' id='Store_ID' value={this.props.storesDetails.Store_ID} />
              </td>
            </tr>
            <tr className={(storedetails ? 'hide-table-row' : 'show-table-row')}>
              <th ><label htmlFor='Store_Number'>{t[language].settingsStoresStoreNumber}
              : {this.authService.isAdmin() ? <span className='redText'>*</span> : this.state.isViewDetailsPage ? <span className='Required'>*</span> : ''}
              </label></th>
              <td><input type='text' maxLength='100' name='Store_Number' id='Store_Number' value={this.props.storesDetails.Store_Number} disabled='disabled' /></td>
            </tr>
            <tr className={this.props.storeModelPopupIsAdmin || storedetails ? 'hide-table-row' : 'show-table-row'}>
              <th><label htmlFor='Group_Name'>{t[language].settingsStoresGroup}:</label></th>
              <td><input type='text' maxLength='100' name='Group_Name' id='Group_Name' value={this.props.storesDetails.Group_Name} disabled='disabled' /></td>
            </tr>
            <tr className={this.props.storeModelPopupIsAdmin || storedetails ? 'hide-table-row' : 'show-table-row'}>
              <th><label htmlFor='Report_Group'>{t[language].StoreSettingsReportGroup}:</label></th>
              <td><input type='text' maxLength='100' name='Report_Group' id='Report_Group' value={this.props.storesDetails.Report_Group} disabled='disabled' /></td>
            </tr>
            <tr>
              <th><label htmlFor='Store_AddressLine1'>{t[language].address1}
                {this.authService.isAdmin() ? <span className='redText'> *</span> : this.state.isViewDetailsPage ? <span style={{ padding: '2px' }} className='Required'>*</span> : ''}</label></th>
              <td><input type='text' maxLength='100' name='Store_AddressLine1' id='Store_AddressLine1' value={this.props.storesDetails.Store_AddressLine1} disabled='disabled' /></td>
            </tr>
            <tr>
              <th><label className='storedetails_Addressline' htmlFor='Store_AddressLine2'>{t[language].address2}</label></th>
              <td><input type='text' maxLength='100' name='Store_AddressLine2' id='Store_AddressLine2' value={this.props.storesDetails.Store_AddressLine2} disabled='disabled' /></td>
            </tr>
            <tr>
              <th><label className='storedetails_Addressline' htmlFor='Store_AddressLine3'>{t[language].address3}</label></th>
              <td><input type='text' maxLength='100' name='Store_AddressLine3' id='Store_AddressLine3' value={this.props.storesDetails.Store_AddressLine3} disabled='disabled' /></td>
            </tr>
            <tr>
              <th><label className='storedetails_Addressline' htmlFor='Store_AddressLine4'>{t[language].address4}</label></th>
              <td><input type='text' maxLength='100' name='Store_AddressLine4' id='Store_AddressLine4' value={this.props.storesDetails.Store_AddressLine4} disabled='disabled' /></td>
            </tr>
            <tr className={storedetails ? 'show-table-row' : 'hide-table-row'}>
              <th><label htmlFor='Group_Name'>{t[language].settingsStoresGroup}</label></th>
              <td><input type='text' maxLength='100' name='Group_Name' id='Group_Name' value={this.props.storesDetails.Group_Name} disabled='disabled' /></td>
            </tr>
            <tr className={storedetails ? 'hide-table-row' : 'show-table-row'} >
              <th><label htmlFor='Store_Locality'>{t[language].settingsStoresStoreCity}
              : {this.authService.isAdmin() ? <span className='redText'>*</span> : ''}</label></th>
              <td><input type='text' maxLength='100' name='Store_Locality' id='Store_Locality' value={this.props.storesDetails.Store_Locality} disabled='disabled' /></td>
            </tr>
            <tr className={storedetails ? 'show-table-row' : 'hide-table-row'} >
              <th><label htmlFor='Store_Locality'>{t[language].settingsStoresStoreCity}
                {this.authService.isAdmin() ? <span className='redText'>*</span> : this.state.isViewDetailsPage ? <span style={{ padding: '3px' }} className='Required'>*</span> : ''}</label></th>
              <td>
                <table className='storedetails'>
                  <tr>
                    <td>
                      <input type='text' maxLength='100' name='Store_Locality' id='Store_Locality' value={this.props.storesDetails.Store_Locality} disabled='disabled' />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr className={storedetails ? 'hide-table-row' : 'show-table-row'}>
              <th><label htmlFor='Store_Region'> {t[language].region}: <span className='redText'>*</span></label></th>
              <td><input type='text' maxLength='100' name='Store_Region' id='Store_Region' value={this.props.storesDetails.Store_Region} disabled='disabled' /></td>
            </tr>
            <tr className={storedetails ? 'hide-table-row' : 'show-table-row'}>
              <th><label htmlFor='Store_PostCode'>{t[language].zip} {this.authService.isAdmin() ? <span className='redText'>*</span> : this.state.isViewDetailsPage ? <span className='redText'>*</span> : ''}</label></th>

              <td><input type='text' maxLength='100' name='Store_PostCode' id='Store_PostCode' value={this.props.storesDetails.Store_PostCode} disabled='disabled' /></td>
            </tr>
            <tr className={storedetails ? 'show-table-row' : 'hide-table-row'} >
              <th><label htmlFor='Store_Region'>  {this.props.storesDetails.Country_ID === 1 ? t[language].state : t[language].region}
              : <span className='Required'>*</span></label></th>
              <td>
                <table className='storedetails'>
                  <tr>
                    <td>
                      <input type='text' maxLength='100' name='Store_Region' id='Store_Region' value={this.props.storesDetails.Store_Region} disabled='disabled' />
                    </td>
                    <th><label htmlFor='Store_PostCode' className='zip'>{t[language].zip} {this.authService.isAdmin() ? <span className='redText'>*</span> : this.state.isViewDetailsPage ? <span className='redText'>*</span> : ''}</label></th>

                    <td><input type='text' maxLength='100' name='Store_PostCode' id='Store_PostCode' value={this.props.storesDetails.Store_PostCode} disabled='disabled' /></td>

                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <th><label htmlFor='Store_Country'>{t[language].settingsStoresCountry} {this.authService.isAdmin() ? <span className='redText'>*</span> : this.state.isViewDetailsPage ? <span className='redText'>*</span> : ''}</label></th>
              <td>
                <select name='Store_Country_ID' id='Store_Country_ID' disabled='disabled'>
                  <CountryOptions countryList={this.props.countries} selectedCountryId={this.props.storesDetails.Country_ID} />
                </select>
              </td>
            </tr>
            <tr className={!this.authService.isAdmin() ? 'hide-table-row' : ' show-table-row'}>
              <th><label htmlFor='Store_TZ'>{t[language].Timezone}
              : {this.authService.isAdmin() ? <span className='redText'>*</span> : ''}</label></th>
              <td>
                <select name='Store_TZ' id='Store_TZ' value={this.state.Store_TZ || ''} disabled={this.checkUserUUID() ? 'disabled' : ''} onChange={(e) => { this.handleInputChange(e) }}>
                  <option value=''>{t[language].SelectTimezone}</option>
                  {timeZoneList(this.state.timeZones, this.state.Store_TZ)}
                </select>
              </td>
            </tr>
            <tr>
              <th><label htmlFor='Store_PhoneNumber'>{t[language].phone} {this.authService.isAdmin() ? <span className='redText'>*</span> : this.state.isViewDetailsPage ? <span className='redText'>*</span> : ''}</label></th>
              <td><input type='text' maxLength='100' name='Store_PhoneNumber' id='Store_PhoneNumber' value={this.props.storesDetails.Store_PhoneNumber} disabled='disabled' /></td>
            </tr>
            <tr>
              <th><label htmlFor='Store_FaxNumber'>{t[language].settingsStoresFax}</label></th>
              <td><input type='text' maxLength='100' name='Store_FaxNumber' id='Store_FaxNumber' value={this.props.storesDetails.Store_FaxNumber} disabled='disabled' /></td>
            </tr>
            <tr />
          </tbody>
        </table>
        <div className={(this.props.storeModelPopupIsAdmin ? 'hide' : 'show') + ' store-details-save Store_savebtn_bottom'}>
          <div className={storedetails ? 'hide-table-row' : 'show-table-row'}>
            <input type='submit' value={t[language].save} className='submit-public' onClick={this.handleSubmit} translate='' key='save' />
        &nbsp; | &nbsp;
            <a className='cancel-public' translate='' onClick={this.props.close} key='settingsStoresCancel'>{t[language].cancel}</a>
          </div>
        </div>
        {/* Showing the remove store button for Admin and stores which are unavailable */}
        <div className={'remove-store-dialog ' + this.authService.isAdmin() ? 'show' : 'hide'}>
          <input className={this.isRemoveStore(this.props.Device_Details) ? 'hide' : 'show' + ' store-remove-button'} type='submit' value={t[language].RemoveStore} onClick={this.handleRemoveStore} />
        </div>
        <input className={(this.props.storeModelPopupIsAdmin ? 'show' : 'hide') + ' store-info-save'} style={saveBtn} type='submit' value={t[language].save} onClick={this.handleSubmit} />
        {this.storeTabs()}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    countries: state.country.countries,
    storesDetails: state.StorePopupDetails.storePopupDetails.storeDetails,
    Device_Details: state.StorePopupDetails.storePopupDetails.Device_Details,
    storeModelPopup: state.StorePopupDetails,
    storeModelPopupIsAdmin: state.StorePopupDetails.storePopUpDetailisAdmin,
    permissions: state.permissions
  }
}

function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getCountryList: getCountryList,
      mergeOpenPopup: mergeOpenPopup,
      closePopup: closePopup,
      getPermission: getPermission
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(StoreDetailsComponent)



// WEBPACK FOOTER //
// ./src/components/Stores/StoreDetailsComponent.js